import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import StudyCalculatorImg from "../../../images/StudyCalculatorImg.webp";
const TITLE = "Calcul de la note sur 100 - Calculatrice de moyenne universitaire";
const DESCRIPTION =
  "Calcul de la note sur 100 - Calculatrice de moyenne universitaire pour suivre vos notes, moyennes et conversions scolaires avec precision. Outil utile pour planifier vos objectifs et mieux piloter votre progression academique.";
const KEYWORDS =
  "calcul de la note sur 100 de moyenne universitaire, calculatrice calcul de la note sur 100 de moyenne universitaire, calcul en ligne, etudes, notes, GPA, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/grade100";
function WeightedGradeCalculator() {
  const [assignments, setAssignments] = useState([
    { name: "Matière 1", grade: "90", weight: "100" },
    { name: "Matière 2", grade: "80", weight: "100" },
    { name: "Matière 3", grade: "70", weight: "100" },
  ]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [weightedScore, setWeightedScore] = useState(0);
  const [weightedGrade, setWeightedGrade] = useState("");
  const [weightedGPA, setWeightedGPA] = useState(0);
  const calculateWeightedGrade = () => {
    setIsLoading(true);
    setError(null);
    let totalWeightedScore = 0;
    let totalWeight = 0;
    for (const assignment of assignments) {
      const grade = parseFloat(assignment.grade);
      const weight = parseFloat(assignment.weight);
      if (!isNaN(grade) && !isNaN(weight)) {
        totalWeightedScore += (grade / 100) * weight;
        totalWeight += weight;
      }
    }
    if (totalWeight === 0) {
      setError("Veuillez entrer des valeurs valides pour les matières et les poids.");
    } else {
      const calculatedWeightedScore = (totalWeightedScore / totalWeight) * 100;
      setWeightedScore(calculatedWeightedScore.toFixed(2));
      const calculatedWeightedGrade = calculateWeightedGradeLetter(
        calculatedWeightedScore
      );
      setWeightedGrade(calculatedWeightedGrade);
      const calculatedWeightedGPA = calculateWeightedGPA(
        calculatedWeightedScore
      );
      setWeightedGPA(calculatedWeightedGPA.toFixed(2));
    }
    setIsLoading(false);
  };
  const calculateWeightedGradeLetter = (weightedScore) => {
    if (weightedScore >= 90) {
      return "A";
    } else if (weightedScore >= 80) {
      return "B";
    } else if (weightedScore >= 70) {
      return "C";
    } else if (weightedScore >= 60) {
      return "D";
    } else {
      return "F";
    }
  };
  const calculateWeightedGPA = (weightedScore) => {
    if (weightedScore >= 90) {
      return 4.0;
    } else if (weightedScore >= 80) {
      return 3.0;
    } else if (weightedScore >= 70) {
      return 2.0;
    } else if (weightedScore >= 60) {
      return 1.0;
    } else {
      return 0.0;
    }
  };
  const addAssignment = () => {
    setAssignments([...assignments, { name: "", grade: "", weight: 100 }]);
  };
  const removeAssignment = (index) => {
    const updatedAssignments = [...assignments];
    updatedAssignments.splice(index, 1);
    setAssignments(updatedAssignments);
  };
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedAssignments = [...assignments];
    updatedAssignments[index][name] =
      name === "weight" && value === "" ? "100" : value;
    setAssignments(updatedAssignments);
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        IMAGE={StudyCalculatorImg}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>{DESCRIPTION}</p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    Calcul de moyenne universitaire sur 100
                  </h2>
                </div>
                <hr />
                <div className="form-group d-flex align-items-center text-center">
                  <div style={{ width: "100%", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="assignment">Devoir/Examen</label>
                    </b>
                  </div>
                  <div style={{ width: "75px", marginLeft: "4px" }}>
                    <b>
                      <label htmlFor="grade">Note</label>
                    </b>
                  </div>

                    <div style={{ width: '75px', marginLeft: '4px', display: 'inline-block' }}>
                      <b><label>Poids</label></b>
                      <button
                        type="button"
                        style={{
                          background: 'none',
                          border: 'none',
                          padding: '0',
                          cursor: 'help',
                          marginLeft: '5px'
                        }}
                        title="Laissez le champ de poids vide si vos matières n'ont pas de poids. La valeur par défaut est 100%"
                      >
                        ℹ️
                      </button>
                    </div>
                  </div>
                {assignments.map((assignment, index) => (
                  <div key={index}>
                    <div className="form-group d-flex align-items-center">
                      <input
                        type="text"
                        name="name"
                        id="assignment"
                        placeholder="Matière/Examen"
                        value={assignment.name}
                        style={{ width: "100%", marginLeft: "4px" }}
                        className="form-control ml-2"
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="grade"
                        id="grade"
                        placeholder="75"
                        value={assignment.grade}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "4px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <input
                        type="number"
                        name="weight"
                        id="weight"
                        placeholder="100"
                        value={assignment.weight}
                        className="form-control ml-2"
                        style={{ width: "75px", marginLeft: "2px" }}
                        onChange={(e) => handleInputChange(index, e)}
                      />
                      <span
                        className="input-group-text "
                        style={{ marginLeft: "4px" }}
                      >
                        %
                      </span>
                      <button
                        className="text-white btn bg-secondary"
                        onClick={() => removeAssignment(index)}
                      >
                        Supprimer
                      </button>
                    </div>
                    <div>
                      <br />
                    </div>
                  </div>
                ))}
                <button
                  className="text-white btn bg-success"
                  onClick={addAssignment}
                >
                  Ajouter une matière/examen
                </button>
                <div>
                  <br />
                </div>
                <button
                  className="text-white btn bg-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateWeightedGrade}
                  disabled={isLoading}
                >
                  Calculer
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-7">
                <br />
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Erreur :</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {weightedScore > 0 && (
                  <div className="bg-light bg-gradient text-dark">
                    <div className="p-3 mb-2 bg-success bg-gradient text-white">
                      <strong>Résultats</strong>
                    </div>
                    <b>Note pondérée (sur 100):</b> {weightedScore}%
                    <br />
                    <b>Note pondérée :</b> {weightedGrade}
                    <br />
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
            <hr />
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                  </u>
                  <p>
                    Pour calculer votre GPA pondéré pour votre année universitaire ou votre unité d'étude ou votre tâche,
                    nous multiplions les notes (ou les notes) par leurs poids correspondants, puis les additionnons ensemble,
                    et ensuite nous divisons le total par la somme des poids. Ci-dessous un exemple et le calcul est affiché
                    en bas des résultats.
                  </p>
                  <table >
                    <tbody>
                      <tr className="gpa-header">
                        <th>Note</th>
                        <th>Poids</th>
                        <th>Unité</th>
                      </tr>
                      <tr>
                        <td>66%</td>
                        <td>20 unités</td>
                        <td>Analyse de données</td>
                      </tr>
                      <tr>
                        <td>55%</td>
                        <td>10 unités</td>
                        <td>Programmation</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WeightedGradeCalculator;
